import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Modal, Button } from "react-bootstrap";
import Swal from 'sweetalert2';
import { API_URL } from '../../../api/api';

const API_EMPLOYEE_PROFILE = `${API_URL}/employee-profiles`;

const ManageEmployeeProfileLayer = () => {
  const [showModal, setShowModal] = useState(false);
  const [profileName, setProfileName] = useState('');
  const [profiles, setProfiles] = useState([]);
  const [editId, setEditId] = useState(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchProfiles();
  }, []);

  const fetchProfiles = async () => {
    try {
      const res = await axios.get(API_EMPLOYEE_PROFILE, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProfiles(res.data);
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'Failed to fetch profiles', 'error');
    }
  };

  const handleSave = async () => {
    if (!profileName.trim()) {
      return Swal.fire('Warning', 'Profile name is required', 'warning');
    }
    try {
      if (editId) {
        await axios.put(`${API_EMPLOYEE_PROFILE}/${editId}`, {
          profile_name: profileName
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        Swal.fire('Updated!', 'Profile updated successfully', 'success');
      } else {
        await axios.post(API_EMPLOYEE_PROFILE, {
          profile_name: profileName
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        Swal.fire('Created!', 'Profile created successfully', 'success');
      }
      setProfileName('');
      setEditId(null);
      setShowModal(false);
      fetchProfiles();
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'Failed to save profile', 'error');
    }
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    });
    if (confirm.isConfirmed) {
      try {
        await axios.delete(`${API_EMPLOYEE_PROFILE}/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        Swal.fire('Deleted!', 'Profile has been deleted.', 'success');
        fetchProfiles();
      } catch (error) {
        console.error(error);
        Swal.fire('Error', 'Failed to delete profile', 'error');
      }
    }
  };

  const handleEdit = (profile) => {
    setEditId(profile.id);
    setProfileName(profile.profile_name);
    setShowModal(true);
  };

  return (
    <div className="row gy-4">
      <div className="col-md-12">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h6>Employee Profiles</h6>
            <Button className="btn btn-sm btn-primary-600" onClick={() => {
              setEditId(null);
              setProfileName('');
              setShowModal(true);
            }}>
              <i className="ri-add-line" /> Add Profile
            </Button>
          </div>
          <div className="card-body">
            <table className="table table-bordered mb-0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Employee Profile</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {profiles.length === 0 ? (
                  <tr><td colSpan="4" className="text-center">No profiles found</td></tr>
                ) : profiles.map(profile => (
                  <tr key={profile.id}>
                    <td>{profile.id}</td>
                    <td>{profile.profile_name}</td>
                    <td>{profile.status}</td>
                    <td>
                      <button className="btn btn-sm btn-info me-2" onClick={() => handleEdit(profile)}>
                        <i className="ri-edit-line" />
                      </button>
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(profile.id)}>
                        <i className="ri-delete-bin-line" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <h6>{editId ? 'Edit Profile' : 'Add Employee Profile'}</h6>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label>Employee Profile</label>
            <input
              type="text"
              className="form-control"
              placeholder="Collection Boy"
              value={profileName}
              onChange={(e) => setProfileName(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave}>
            {editId ? 'Update' : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ManageEmployeeProfileLayer;
